/**
 * RESPONSIBILITY: the Give page - how to give.
 *
 * The House of Honor appeal makes its case on a page of its own, not here: this page
 * answers how to act once somebody has already decided to.
 *
 * No @EditableBy, so WRITE defaults to NONE - admin only.
 */
import { Section, Text, Paragraph, Link, List } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { WayToGive } from './rows/way-to-give';
import { ABOVE_HINT, LINK_HINT } from '../hints';

@Section({ name: SectionName.Give, label: 'Give page' })
export class GiveSection {
  @Text({
    label: 'Subtitle', maxLength: 120, default: 'Give',
    group: 'Page head', description: ABOVE_HINT,
  })
  eyebrow!: string;
  @Text({ label: 'Title', maxLength: 300, default: 'Giving at ACFI', group: 'Page head' })
  heading!: string;
  @Paragraph({ label: 'Description', maxLength: 4000, rows: 3, group: 'Page head' })
  intro!: string;

  @Text({ label: 'Title', maxLength: 120, default: 'Ways to give', group: 'Ways to give' })
  waysHeading!: string;
  @List({ label: 'Ways to give', of: () => WayToGive, maxItems: 8 })
  ways!: WayToGive[];

  @Text({
    label: 'Title', maxLength: 300, default: 'Questions about giving?',
    group: 'Closing invitation', collapsed: true,
  })
  askHeading!: string;
  @Paragraph({
    label: 'Text', maxLength: 4000, rows: 2, group: 'Closing invitation',
    default: 'We are glad to talk it through — there is no pressure either way.',
  })
  askBody!: string;
  @Text({ label: 'Button text', maxLength: 120, default: 'Contact us', group: 'Closing invitation' })
  askCtaLabel!: string;
  @Link({ label: 'Button link', group: 'Closing invitation', description: LINK_HINT })
  askCtaHref!: string;
}
